import React, { useState } from 'react';
import { toast } from 'react-toast';
import { RtModal, RtModalField } from '../ui/RtModal';

const ApiKeyModal = ({ isOpen, onClose, onSave, toolName }) => {
  const [apiKey, setApiKey] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (!isOpen) return null;

  const handleSaveClick = () => {
    if (!apiKey.trim()) {
      toast.error('Please enter the API key');
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    onSave(toolName, apiKey);
    setShowConfirmation(false);
  };

  const handleCancelConfirm = () => {
    setShowConfirmation(false);
  };

  const handleClose = () => {
    setApiKey('');
    setShowConfirmation(false);
    onClose();
  };

  return (
    <>
      <RtModal
        open={isOpen && !showConfirmation}
        onClose={handleClose}
        title={`Enter API Key for ${toolName}`}
        size="sm"
        footer={
          <>
            <button type="button" className="rt-btn rt-btn--secondary" onClick={handleClose}>
              Cancel
            </button>
            <button type="button" className="rt-btn rt-btn--primary" onClick={handleSaveClick}>
              Save
            </button>
          </>
        }
      >
        <RtModalField label="API key" htmlFor="api-key-input" required>
          <input
            id="api-key-input"
            type="text"
            placeholder="Enter your API key here"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
        </RtModalField>
      </RtModal>

      <RtModal
        open={showConfirmation}
        onClose={handleCancelConfirm}
        title="Confirm API Tool Selection"
        size="sm"
        variant="confirm"
        footer={
          <>
            <button
              type="button"
              className="rt-btn rt-btn--secondary"
              onClick={handleCancelConfirm}
            >
              Cancel
            </button>
            <button type="button" className="rt-btn rt-btn--primary" onClick={handleConfirm}>
              Confirm
            </button>
          </>
        }
      >
        <div className="rt-modal-confirm">
          <p className="rt-modal-confirm__message">
            Are you sure you want to use <strong>{toolName}</strong> as your AI tool?
          </p>
        </div>
      </RtModal>
    </>
  );
};

export default ApiKeyModal;
